import {
    booleanAttribute,
    Component,
    inject,
    input,
    Input,
} from '@angular/core';
import {
    ControlContainer,
    FormControl,
    ReactiveFormsModule,
} from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { TranslatePipe } from '@ngx-translate/core';
import { TextareaElementModel } from '../../../models/clientsform/textarea-element.model';
import { LocalizationService } from '../../../services/localization.service';
import { TranslationComponent } from '../../translation/translation.component';

@Component({
    selector: 'apcam-textarea-element',
    imports: [
        MatFormFieldModule,
        MatInputModule,
        ReactiveFormsModule,
        TranslatePipe,
        TranslationComponent,
    ],
    templateUrl: './textarea-element.component.html',
    styleUrl: './textarea-element.component.scss',
    viewProviders: [
        {
            provide: ControlContainer,
            useFactory: () => inject(ControlContainer, { skipSelf: true }),
        },
    ],
})
export class TextareaElementComponent {
    @Input({ required: true })
    public formcontrolName!: string;

    @Input({ required: true })
    public inputConfig!: TextareaElementModel;

    public readonly showPlaceholder = input(true, {
        transform: booleanAttribute,
    });

    protected get currentLang() {
        return this.localizationService.getCurrentLanguage();
    }

    protected get input() {
        return this.controlContainer.control?.get([
            this.formcontrolName,
        ]) as FormControl;
    }

    private readonly controlContainer = inject(ControlContainer);
    private readonly localizationService = inject(LocalizationService);
}
